import store from '@/store';

export function orgGuard(to, _from, next) {
  if (!to.meta.requiresOrgMember) return next();
  if (store.getters.isOrgMember) return next();
  return next('/console/getstarted');
}
